import clsx from "clsx";
import { ArrowLeftRight } from "lucide-react";

/**
 * Where a record lives, as a small icon just before its name wherever it's listed, searched or
 * picked (hover for the words): green for synced with ServiceM8, grey for kept only in this app.
 * `onDark`: on a coloured bar (a record window's title), where it shows in white.
 */
export function SyncBadge({ synced, onDark }: Readonly<{ synced: boolean; onDark?: boolean }>) {
    const label = synced ? "Synced with ServiceM8: kept in step both ways" : "Only in this app: not in ServiceM8, so it can't be used on jobs";
    let colour = synced ? "text-brand-500" : "text-muted/50";
    if (onDark) colour = synced ? "text-white" : "text-white/50";
    return (
        <span title={label} aria-label={label} role="img" className="inline-flex shrink-0">
            <ArrowLeftRight className={clsx("size-3.5", colour)} />
        </span>
    );
}
